<template>
  <section class="simulados box-branco">
    <div class="d-flex justify-content-around align-items-start align-items-lg-center titulo flex-column flex-lg-row">
        <span class="nomeSimulado mb-4 mb-lg-0">{{ nome }}</span>
        <div>
          <span class="numeroQuestaoRoxo">{{ configEmpresa.textosConfiguraveis.textoDisplaySimulado }} finalizado</span>
        </div>
    </div>
    <div class="container">
        <div class="row simuladoResultado">
          <div class="col-lg-6 col-12">
            <img :src="imgResultado" class="img-fluid">
            <p class="acertou mb-4">Você acertou {{ quantidadeAcertos }} de {{ quantidadeAcertos + quantidadeErros + quantidadeNaoRespondidas }} questões!</p>
            <p class="continueEstudando">Continue estudando e aprofunde seu conhecimento usando outras ferramentas de estudo</p>
          </div>
          <div class="col-lg-6 col-12 mb-4">
            <p class="tempoSimulado mb-3">{{ tempoRealizacaoSimulado }}</p>
            <p class="tempoTotalTexto mb-4">Tempo total no simulado</p>
            <div class="estatisticasSimulado d-flex justify-content-center mb-5">
              <div class="d-flex flex-column align-items-center">
                <p class="acertos">{{ quantidadeAcertos }}</p>
                <span>Acertos</span>
              </div>
              <div class="d-flex flex-column align-items-center">
                <p class="erros">{{ quantidadeErros }}</p>
                <span>Erros</span>
              </div>
              <div class="d-flex flex-column align-items-center">
                <p class="naoRespondidas">{{ quantidadeNaoRespondidas }}</p>
                <span>Não respondidas</span>
              </div>
            </div>
            <div class="revisaoSimulados">
              <a href="javascript:void(0)" @click="$router.push(`/simulados/prova/${simuladoId}/questao/${questoes.find(item => item.errada).ordem}/revisao/erros`)" v-if="quantidadeErros > 0">
                <button class="btnRevisao btn mb-3">
                  Revisar as que errei
                </button>
              </a>
              <a href="javascript:void(0)" @click="$router.push(`/simulados/prova/${simuladoId}/questao/${questoes.find(item => item.errada).ordem}/revisao/acertos`)" v-if="quantidadeAcertos > 0">
                <button class="btnRevisao btn mb-3">
                  Revisar as que acertei
                </button>
              </a>
              <a href="javascript:void(0)" @click="$router.push(`/simulados/prova/${simuladoId}/questao/${questoes.find(item => item.naoRespondida).ordem}/revisao/nao-respondidas`)" v-if="quantidadeNaoRespondidas > 0">
                <button class="btnRevisao btn mb-3">
                  Revisar as que pulei
                </button>
              </a>
              <a href="javascript:void(0)" @click="$router.push(`/simulados/prova/${simuladoId}/questao/1/revisao/todas`)">
                <button class="btnRevisao btn mb-3">
                  Revisar todas as questões
                </button>
              </a>
              <a href="javascript:void(0)" @click="zerarRecomecar()">
                <button class="btnRevisao btn mb-5 zerar">
                  Zerar e recomeçar
                </button>
              </a>
              <a href="javascript:void(0)" @click="$router.push('/simulados')">
                <button class="btnRevisao btn iniciarOutro">
                  Iniciar outro {{ configEmpresa.textosConfiguraveis.textoDisplaySimulado }}
                </button>
              </a>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import SimuladoAPI from '@/api/simulado-api'
import ResponseUtils from '@/core/utils/response-utils'
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'SimuladoResultadoView',
  data () {
    return {
      nome: '',
      simuladoId: null,
      questoes: [],
      quantidadeAcertos: 0,
      quantidadeErros: 0,
      quantidadeNaoRespondidas: 0,
      tempo: { minutos: 0, segundos: 0 },
      temas: [],
      items: {},
      options: {
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              const serie = data.datasets[0].data[tooltipItem.index]

              if (label.split(' ').length > 1) {
                return label.split(' ')[0]
              } else {
                return `${label}: ${serie}`
              }
            },
            afterLabel: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              const serie = data.datasets[0].data[tooltipItem.index]

              if (label.split(' ').length > 1) {
                return `${label.split(' ')[1]}: ${serie}`
              }
            }
          }
        }
      }
    }
  },

  computed: {
    tempoRealizacaoSimulado: function () {
      return `${String(this.tempo.minutos).padStart(2, '0')}:${String(this.tempo.segundos).padStart(2, '0')}`
    },

    configEmpresa: function () {
      return this.$store.getters.empresa
    },

    imgResultado: function () {
      return ImageUtils.obterUrlCompletaImagem('img-feedback-simulado.svg', 'img/')
    }
  },

  created () {
    this.simuladoId = parseInt(this.$route.params.simulado)
  },

  async mounted () {
    const loader = this.$loading.show()

    await SimuladoAPI.obterResultado(this.simuladoId).then(data => {
      this.questoes = data.map(item => {
        return {
          ordem: item.ordem,
          correta: item.resposta && item.resposta === item.opcao_correta,
          naoRespondida: !item.resposta,
          errada: item.resposta && item.resposta !== item.opcao_correta
        }
      })

      this.quantidadeAcertos = this.questoes.filter(item => item.correta).length
      this.quantidadeNaoRespondidas = this.questoes.filter(item => item.naoRespondida).length
      this.quantidadeErros = this.questoes.filter(item => item.errada).length

      this.items = {
        labels: ['Acertos', 'Erros', 'Não respondidas'],
        datasets: [{
          data: [this.quantidadeAcertos, this.quantidadeErros, this.quantidadeNaoRespondidas],
          backgroundColor: [ '#4DCDCC', '#F47D3A', '#B6C7DE' ],
          borderColor: [ 'rgba(255,255,255,1)' ],
          borderWidth: 1
        }]
      }
    })

    await SimuladoAPI.obterTempoRealizacaoSimulado(this.simuladoId).then(data => {
      this.tempo = data
    })

    // await SimuladoAPI.obterResultadoPorTema(this.simuladoId).then(data => {
    //   this.temas = data.disciplinas
    // })

    await SimuladoAPI.obterQuestaoSimulado(this.simuladoId).then(data => {
      this.nome = data.etapa.simulado_nome
    })

    loader.hide()
  },

  methods: {
    zerarRecomecar: function () {
      const loader = this.$loading.show()

      SimuladoAPI.refazer(this.simuladoId).then(() => {
        window.location = `/simulados/prova/${this.simuladoId}/questao/1`
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  }
}
</script>

<style scoped>

</style>
